import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable, map, filter  } from 'rxjs';
import { DataService } from '../service/data.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private _dataService: DataService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this._dataService.user$.pipe(
          filter(user => !!user),
          map(user => {
            const companyId = route.paramMap.get('company')
            if (!companyId){
              return true;
            };
            const hasAccess = user.roles.some(r => r._id === companyId) || user.ownCompanies$.value.some(r => r.id === companyId);
            return hasAccess;
          })
        );
  }
}
